APP.Overlay = (/** @lends APP.Overlay */function () {
	'use strict';

	var exports,
		$body,
		overlayActive,
		$overlay,
		$overlayContent,
		contentHistory = [];

	function init() {
		initDOMElements();
		initBindings();
	}

	function initDOMElements() {
		$body = APP.Performance.getCachedDOM().$body;
		$overlay = $body.find('[data-overlay]');
		$overlayContent = $overlay.find('[data-overlay-content]');
	}

	function initBindings() {
		$body.on('click.close-overlay', '[data-close-overlay]', function (e) {
			APP.Overlay.close();
			e.preventDefault();
		});

		$body.on({
			keydown: function (e) {
				if (overlayActive && e.keyCode === 27) {
					e.preventDefault();
					close();
				}
			}
		});
	}

	function setContent(content, addToHistory, resetHistory, addClass) {
		if (resetHistory) {
			contentHistory = [];
		}

		if (addToHistory) {
			contentHistory.push(content);
		}

		if (addClass) {
			$overlay.addClass(addClass);
		}

		$overlayContent.html(content);
		APP.Tooltip.updateWithin($overlayContent);
	}

	function open() {
		$body.addClass('body--disable-scroll');
		overlayActive = true;
		$overlay.show();
	}

	function close() {
		contentHistory.pop();
		$body.removeClass('body--disable-scroll');
		overlayActive = false;
		$overlay.hide();
		$overlay.removeClass('overlay--error');
		if (contentHistory.length > 0) {
			setContent(contentHistory[contentHistory.length - 1]);
			open();
		}

	}

	function openWithTpl(templateName, data) {
		var $template = APP.Template.get(templateName);

		APP.Overlay.setContent($template(data || {}));
		APP.Overlay.open();
	}

	exports = {
		init: init,
		open: open,
		openWithTpl: openWithTpl,
		close: close,
		setContent: setContent
	};

	/* test-code */
	/* eslint no-underscore-dangle: 0 */
	exports.__testonly__ = {};
	/* end-test-code */

	return exports;

}());
